import React, { useState } from 'react';
import { View, StyleSheet, Platform, Text } from 'react-native';
import { colores } from '../../styles/variablesCss';
import DatosUsuario from '../Home/Header/AdminUsuario/DatosUsuario';
import AddDireccion from './AddDireccion';
import { BACKEND_URL } from '../../Config/Const';
import Storage from '../../utils/Storage';

const CargarDatos = ({ onClose }) => {
  const [showAddDireccion, setShowAddDireccion] = useState(false);

  const fetchDireccionesYDecidir = async () => {
    try {
      let mail = '';
      let codUsu = '';
      if (Platform.OS === 'web' && typeof window !== 'undefined') {
        mail = localStorage.getItem('mail') || '';
        codUsu = localStorage.getItem('codUsu') || '';
      } else {
        mail = await Storage.getItem('mail') || '';
        codUsu = await Storage.getItem('codUsu') || '';
      }

      const params = new URLSearchParams();
      if (mail) params.append('mail', mail);
      if (codUsu) params.append('codUsu', codUsu);

      const resp = await fetch(`${BACKEND_URL}/rest/usuarios/direcciones?${params.toString()}`, {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
      });
      if (!resp.ok) throw new Error('network');
      const data = await resp.json();
      const dirs = Array.isArray(data?.dsResultado?.direcciones) ? data.dsResultado.direcciones : [];
      if (dirs.length === 0) {
        setShowAddDireccion(true);
      } else {
        if (typeof onClose === 'function') onClose();
      }
    } catch {
      if (typeof onClose === 'function') onClose();
    }
  };

  const handleSaved = () => {
    fetchDireccionesYDecidir();
  };

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <View style={styles.topBorder} />
        <View style={styles.header}> 
          <Text style={styles.title}>Necesitamos que completes tus datos para continuar</Text>
        </View>
        <View style={styles.padding}>
          <DatosUsuario onSaveChanges={handleSaved} />
        </View>
        {showAddDireccion && (
          <AddDireccion
            visible={showAddDireccion}
            onClose={() => {
              setShowAddDireccion(false);
              if (typeof onClose === 'function') onClose();
            }}
            onSaveDireccion={() => {
              setShowAddDireccion(false);
              if (typeof onClose === 'function') onClose();
            }}
          />
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Platform.OS === 'web' ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16,
  },
  content: {
    width: '100%',
    maxWidth: 700,
    backgroundColor: '#fff',
    borderRadius: 8,
    overflow: 'hidden',
    borderWidth: Platform.OS === 'web' ? 0 : 0,
    // Sombra ligera y borde superior rojo sutil para coherencia visual
    ...(Platform.OS === 'web'
      ? { boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }
      : {
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 4 },
          shadowOpacity: 0.15,
          shadowRadius: 8,
          elevation: 6,
        }
    ),
    borderBottomWidth: 3,
    borderBottomColor: colores.rojo,

  },
  topBorder: {
    width: '100%',
    height: 4,
    backgroundColor: colores.rojo,
  },
  header: {
    paddingHorizontal: 16,
    paddingTop: 16,
    paddingBottom: 8,
   
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
    color: colores.textoPrincipal,
  },
  padding: {
    paddingHorizontal: 16,
    paddingBottom: 16,
  },
});

export default CargarDatos;
